import React from 'react';
import Link from 'next/link';
import { ComponentNode } from '../types/template';
import { convertStylesToInline } from '../utils/styleUtils';
import { resolveCustomThemeHref } from '../utils/linkHelpers';
import { getNestedValue, hasRenderableValue } from '../utils/dataBinding';

interface ButtonComponentProps {
    component: ComponentNode;
    data?: any;
    context?: {
        store_slug?: string;
        slug_type?: string;
        category_slug?: string;
        promotion_slug?: string;
        out_link?: string;
    };
}

const ButtonComponent: React.FC<ButtonComponentProps> = ({ component, data, context }) => {
    const { data: componentData, styles, placeholder, href, customClassName, hideIfEmpty } = component;
    const inlineStyles = convertStylesToInline(styles);

    // e.g. hide the CTA when the API item has no real link to send users to.
    if (hideIfEmpty && !hasRenderableValue(getNestedValue(data, hideIfEmpty))) {
        return null;
    }

    const isReadMore = placeholder === 'read_more_url';
    const resolvedHref = resolveCustomThemeHref(href, data, context);
    const dynamicValue = placeholder !== undefined ? getNestedValue(data, placeholder) : undefined;
    const url = resolvedHref || (isReadMore
        ? dynamicValue || data?.link || componentData || '#'
        : '#');

    const label = isReadMore
        ? componentData
        : typeof dynamicValue === 'string'
            ? dynamicValue.trim() || componentData
            : dynamicValue ?? componentData;

    return (
        <Link href={url || '#'}>
            <button
                style={inlineStyles}
                className={[customClassName, 'px-4 py-2 rounded-full font-medium hover:opacity-90 transition-opacity'].filter(Boolean).join(' ')}
            >
                {label}
            </button>
        </Link>
    );
};

export default ButtonComponent;